import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'timesheet-day-header',
  templateUrl: './timesheet-day-header.component.html',
})
export class TimesheetDayHeaderComponent {
  @Input()
  title: string;
  @Input()
  showAsFooter: boolean;

  @HostBinding('style.height.px')
  height = 36;
}
